<template>
  <div>
    <template v-for="field in fields">
      <ValueHelpWrapper
        v-if="field.type == 'report-filter-value-help'"
        :key="`${field.name}-${field.disabled}`"
        v-b-tooltip.hover="{
          title: field.disabledTooltip,
          disabled: !field.disabled,
        }"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="($event) => updateFormValues($event, field)"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput v-else v-bind="field" :key="field.name" />
      <div v-if="field.isRequired" :key="`required-${field.name}`" class="ms-1 mt-1 fst-italic">
        <span class="text-danger">*</span> {{ $t('report.filters.required') }}
      </div>
    </template>
  </div>
</template>

<script>
import { GET_VEHICLE_TYPES } from '@/services/api/master/fleet'
import { mapGetters } from 'vuex'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'

import { GET_VGROUPS_PAGINATED } from '@/services/api/vehicle/vgroup'

export default {
  components: {
    ValueHelpWrapper,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    formValues: {
      type: Object,
      default: () => ({}),
    },
    fullObjects: {
      type: Object,
      default: () => ({}),
    },
    parameter: {
      type: String,
      default: 'filter',
    },
  },
  emits: ['update:formValues', 'update:fullObjects'],
  data() {
    return {
      filterVehicleType: '',
      filterVehicleGroup: '',
      parameterFilter: this.config[this.parameter] || this.config.filter,
      vehicleTypeId: null,
      vehicleGroupId: null,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    fields() {
      const fields = []
      if (this.parameterFilter?.vehicleGroupId) {
        const vehicleGroupField = this.vehicleGroupField
        vehicleGroupField.isRequired = this.parameterFilter.vehicleGroupId.required ?? false
        fields.push(vehicleGroupField)
      }
      if (this.parameterFilter?.vehicleTypeId) {
        const vehicleTypeField = this.vehicleTypeField
        vehicleTypeField.isRequired = this.parameterFilter.vehicleTypeId.required ?? false
        fields.push(vehicleTypeField)
      }

      return fields
    },
    vehicleTypeField() {
      return {
        name: 'vehicleTypeId',
        isShow: true,
        label: this.$t('dashboard.table.vehicleType'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('dashboard.table.vehicleType')}`,
        trackBy: 'id',
        displayedBy: 'type',
        listGetter: (filter) => this.getVehicleTypeList(filter),
        multiple: this.isArrayValue(this.config, 'vehicleTypeId'),
        tableFields: [
          {
            label: this.$t('dashboard.table.manufacturer'),
            key: 'manufacturer',
          },
          {
            label: this.$t('dashboard.table.model'),
            key: 'model',
          },
          {
            label: this.$t('dashboard.table.type'),
            key: 'type',
          },
        ],
      }
    },
    vehicleGroupField() {
      return {
        name: 'vehicleGroupId',
        isShow: true,
        label: this.$t('dashboard.table.vehicleGroup'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t(
          'dashboard.table.vehicleGroup'
        )}`,
        trackBy: 'id',
        displayedBy: 'name',
        listGetter: (filter) => this.getVehicleGroupList(filter),
        multiple: this.isArrayValue(this.config, 'vehicleGroupId'),
        tableFields: [
          {
            label: this.$t('dashboard.table.vehicleGroup'),
            key: 'name',
          },
        ],
        disabled: !!(
          this.vehicleTypeId &&
          this.vehicleTypeId.length &&
          (!this.vehicleGroupId || !this.vehicleGroupId.length)
        ),
        disabledTooltip: this.$t('dashboard.text.disabledFilterTooltip'),
      }
    },
  },
  methods: {
    loadDataFilter(filter) {
      this.vehicleTypeId = filter.vehicleTypeId
      this.vehicleGroupId = filter.vehicleGroupId
    },
    updateFormValues($event, field) {
      if (field.name == 'vehicleTypeId') {
        this.vehicleTypeId = $event
      } else if (field.name == 'vehicleGroupId') {
        this.vehicleGroupId = $event
      }
      this.$emit('update:formValues', { key: field.name, value: $event })
    },
    isArrayValue(config, prop) {
      if (config.filter && config.filter[prop]) {
        return Array.isArray(config.filter[prop].value)
      }
      return false
    },
    getFilterValue(interval, type) {
      return new Promise((resolve) => {
        const { loaded, list } = this.getListFilterLoaded(type)
        if (!loaded) {
          const intervalId = setInterval(() => {
            const { loaded, list } = this.getListFilterLoaded(type)
            if (loaded) {
              clearInterval(intervalId)
              resolve(list)
            }
          }, interval)
        } else {
          resolve(list)
        }
      })
    },
    async getVehicleTypeList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_VEHICLE_TYPES,
        variables: {
          filter: {
            hasVehicle: true,
            isActive: true,
            hasFuelSensor: true,
            vgroupId:
              this.vehicleGroupId && this.vehicleGroupId.length ? this.vehicleGroupId : undefined,
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.vehicleTypes.vehicleTypes }
      res.data = res.data.map((item) => {
        return {
          ...item,
          id: item.vehicleTypeId,
        }
      })
      return res
    },
    async getVehicleGroupList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_VGROUPS_PAGINATED,
        variables: {
          filter: {
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.vgroupsPaginated.vgroups }
      return res
    },
  },
}
</script>
